export const asRigSidebar = {
  data: `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <rect x="8" y="4" width="8" height="2" rx="1"/>
  <rect x="16.1406" y="17.375" width="9.01914" height="1" rx="0.5" transform="rotate(-150 16.1406 17.375)"/>
  <rect x="15.6406" y="12.8672" width="9.01914" height="1" rx="0.5" transform="rotate(150 15.6406 12.8672)"/>
  <rect width="8" height="1" rx="0.5" transform="matrix(-0.866025 -0.5 -0.5 0.866025 16.4277 11)"/>
  <rect width="8" height="1" rx="0.5" transform="matrix(-0.866025 0.5 0.5 0.866025 14.4277 7)"/>
  <rect x="5.44629" y="19.0059" width="15.0003" height="2" rx="1" transform="rotate(-75 5.44629 19.0059)"/>
  <rect width="15.0017" height="2" rx="1" transform="matrix(0.258819 0.965926 0.965926 -0.258819 12.8701 5.01562)"/>
  <rect x="4" y="18" width="16" height="2" rx="1"/>
  </svg>`,
  name: 'rigSidebar',
};
